import { useState } from "react";
import { Dayjs } from "dayjs";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { OutlinedInputProps } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { pl } from "date-fns/locale";
import styled from "styled-components";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { theme } from "../../../../helpers/theme";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import React from "react";

interface DatePickersProps {
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  OrderInfos: any;
  setFromDate: (fromDate: Dayjs | null) => void;
  setToDate: (toDate: Dayjs | null) => void;
  setDateFromError: (error: string | null) => void;
  setDateToError: (error: string | null) => void;
}
const DatePickers = ({
  fromDate,
  toDate,
  OrderInfos,
  setFromDate,
  setToDate,
  setDateFromError,
  setDateToError,
}: DatePickersProps) => {
  const [inputFromMargin, setInputFromMargin] = useState(
    OrderInfos?.termin_rozpoczecia ? true : false
  );
  const [inputToMargin, setInputToMargin] = useState(
    OrderInfos?.termin_zakonczenia ? true : false
  );

  return (
    <LocalizationProvider adapterLocale={pl} dateAdapter={AdapterDateFns}>
      <DatePickersWrapper>
        <DesktopDatePicker
          views={["day"]}
          label="Data od"
          disablePast
          value={fromDate}
          InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
          onChange={(newValue) => {
            setFromDate(newValue);
            setInputFromMargin(true);
          }}
          onError={(error) => setDateFromError(error)}
          InputAdornmentProps={{ style: { marginLeft: "0" } }}
          OpenPickerButtonProps={{ style: { padding: "0" } }}
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={null}
              variant="standard"
              sx={{
                marginBottom: inputFromMargin ? "0px" : "14px",
                width: "100px",
              }}
              onFocus={() => {
                if (!inputFromMargin) setInputFromMargin(true);
              }}
              onBlur={() => {
                if (inputFromMargin && fromDate === null)
                  setInputFromMargin(false);
              }}
            />
          )}
        />
        <DatesGap>-</DatesGap>

        <DesktopDatePicker
          views={["day"]}
          label="Data do"
          disablePast
          minDate={fromDate}
          value={toDate}
          InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
          onChange={(newValue) => {
            setToDate(newValue);
            setInputToMargin(true);
          }}
          onError={(error) => setDateToError(error)}
          InputAdornmentProps={{ style: { marginLeft: "0" } }}
          OpenPickerButtonProps={{ style: { padding: "0" } }}
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={null}
              variant="standard"
              sx={{
                marginBottom: inputToMargin ? "0px" : "14px",
                marginRight: "13px",
                width: "100px",
              }}
              onFocus={() => {
                if (!inputToMargin) setInputToMargin(true);
              }}
              onBlur={() => {
                if (inputToMargin && toDate === null) setInputToMargin(false);
              }}
            />
          )}
        />
      </DatePickersWrapper>
    </LocalizationProvider>
  );
};

export default DatePickers;

const DatePickersWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32%;
  @media (min-width: 1250px) {
    gap: 12%;
  }
  gap: 5%;
  border-left: 1px solid ${theme.colors.gray04_background};
  border-right: 1px solid ${theme.colors.gray04_background};
`;
const DatesGap = styled.span`
  width: 0%;
  margin-left: 10px;
`;
